/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse }             from '@angular/common/http';
import { Observable, throwError }                            from 'rxjs';
import { catchError, map }                                   from 'rxjs/operators';

import * as models                                           from '../model/models';
import { COLLECTION_FORMATS }                                from '../variables';
import { ApiConfiguration }                                  from '../configuration';
import { ModelRegistry, PagedArray, LoggerService }          from '../../common';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class UsersApi {
    protected basePath = '';
    public defaultHeaders: Record<string,string> = {};
    public configuration: ApiConfiguration = new ApiConfiguration();

    constructor(
        protected http: HttpClient, 
        @Optional() configuration: ApiConfiguration,
        protected logger: LoggerService
    ) {
        if (configuration) {
            this.configuration = configuration;
        }

        if (configuration && configuration.basePath)
            this.basePath = configuration.basePath;
    }

    /**
     * 
     * 
     * @param body 
     */
    public emailConflict(body?: models.PostUsersEmailConflictRequest, __unused?: any): Observable<{}> {
        return this.emailConflictRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public getHonorRoll(__unused?: any): Observable<PagedArray<models.ApiHonorRoll>> {
        return this.getHonorRollRequest(__unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('HonorRoll', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type HonorRoll`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type HonorRoll`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param email 
     */
    public giftEligibleByEmail(email?: string, __unused?: any): Observable<models.ApiGiftEligibility> {
        return this.giftEligibleByEmailRequest(email, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('GiftEligibility', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type GiftEligibility`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type GiftEligibility`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public signupNewsletter(body?: models.PostUsersSignupNewsletterRequest, __unused?: any): Observable<{}> {
        return this.signupNewsletterRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public signup(body?: models.PostUsersSignupRequest, __unused?: any): Observable<models.ApiUserAuthToken> {
        return this.signupRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserAuthToken', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserAuthToken`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserAuthToken`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public confirmEmail(body?: models.PostUsersConfirmemailRequest, __unused?: any): Observable<models.ApiUserAuthToken> {
        return this.confirmEmailRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserAuthToken', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserAuthToken`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserAuthToken`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * Resend confirmation email
     * 
     * @param body 
     */
    public sendConfirmationEmail(body?: models.PostUsersSendconfirmationemailRequest, __unused?: any): Observable<{}> {
        return this.sendConfirmationEmailRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public unlockAccount(body?: models.PostUsersUnlockaccountRequest, __unused?: any): Observable<{}> {
        return this.unlockAccountRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * Send an email to unlock account
     * 
     * @param body 
     */
    public requestAccountUnlock(body?: models.PostUsersRequestunlockRequest, __unused?: any): Observable<{}> {
        return this.requestAccountUnlockRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public resetPassword(body?: models.PostUsersResetpasswordRequest, __unused?: any): Observable<models.ApiUserAuthToken> {
        return this.resetPasswordRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserAuthToken', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserAuthToken`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserAuthToken`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * Assume a user by token
     * 
     */
    public assume(__unused?: any): Observable<models.ApiUserAuthToken> {
        return this.assumeRequest(__unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserAuthToken', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserAuthToken`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserAuthToken`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * Send a password reset request
     * 
     * @param body 
     */
    public requestPasswordReset(body?: models.PostUsersRequestpasswordresetRequest, __unused?: any): Observable<{}> {
        return this.requestPasswordResetRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * Authenticate using twitter, facebook, or google oauth credentials
     * 
     * @param body 
     */
    public userOmniauthAuth(body?: models.PostUsersOmniauthRequest, __unused?: any): Observable<models.ApiUserAuthToken> {
        return this.userOmniauthAuthRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserAuthToken', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserAuthToken`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserAuthToken`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public authenticate(body?: models.PostUsersAuthRequest, __unused?: any): Observable<models.ApiUserAuthToken> {
        return this.authenticateRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserAuthToken', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserAuthToken`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserAuthToken`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public postUsersSso(__unused?: any): Observable<{}> {
        return this.postUsersSsoRequest(__unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public getPaymentSource(__unused?: any): Observable<models.ApiPaymentSource> {
        return this.getPaymentSourceRequest(__unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('PaymentSource', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type PaymentSource`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type PaymentSource`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param page 
     */
    public getAccountTransactions(page?: number, __unused?: any): Observable<PagedArray<models.ApiAccountTransaction>> {
        return this.getAccountTransactionsRequest(page, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('AccountTransaction', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type AccountTransaction`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type AccountTransaction`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public deleteCurrentUser(body?: models.PostUsersCurrentDeleteRequest, __unused?: any): Observable<models.ApiDeletionConfirmation> {
        return this.deleteCurrentUserRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('DeletionConfirmation', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type DeletionConfirmation`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type DeletionConfirmation`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public getCurrentUser(__unused?: any): Observable<models.ApiUser> {
        return this.getCurrentUserRequest(__unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('User', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type User`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type User`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public updateUser(body?: models.PostUsersCurrentRequest, __unused?: any): Observable<models.ApiUser> {
        return this.updateUserRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('User', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type User`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type User`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param code 
     */
    public getRetentionOffer(code?: string, __unused?: any): Observable<models.ApiRetentionOfferSet> {
        return this.getRetentionOfferRequest(code, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('RetentionOfferSet', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type RetentionOfferSet`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type RetentionOfferSet`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public reactivateMembership(__unused?: any): Observable<models.ApiMembership> {
        return this.reactivateMembershipRequest(__unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('Membership', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type Membership`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type Membership`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public cancelMembership(body?: models.PostUsersCurrentMembershipCancelRequest, __unused?: any): Observable<models.ApiMembership> {
        return this.cancelMembershipRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('Membership', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type Membership`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type Membership`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public previewMembershipChange(body?: models.PostUsersCurrentMembershipModifyPreviewRequest, __unused?: any): Observable<models.ApiMembershipChangePreview> {
        return this.previewMembershipChangeRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('MembershipChangePreview', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type MembershipChangePreview`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type MembershipChangePreview`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public modifyMembership(body?: models.PostUsersCurrentMembershipModifyRequest, __unused?: any): Observable<models.ApiMembership> {
        return this.modifyMembershipRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('Membership', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type Membership`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type Membership`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public refreshAuthentication(body?: models.PostUsersAuthRefreshRequest, __unused?: any): Observable<models.ApiUserAuthToken> {
        return this.refreshAuthenticationRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserAuthToken', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserAuthToken`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserAuthToken`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public changePaymentSource(body?: models.PostUsersCurrentMembershipChangepaymentRequest, __unused?: any): Observable<models.ApiMembership> {
        return this.changePaymentSourceRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('Membership', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type Membership`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type Membership`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public createMembership(body?: models.PostUsersCurrentMembershipRequest, __unused?: any): Observable<models.ApiMembership> {
        return this.createMembershipRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('Membership', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type Membership`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type Membership`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public updateProfile(body?: models.PostUsersCurrentProfileRequest, __unused?: any): Observable<models.ApiUserProfile> {
        return this.updateProfileRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserProfile', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserProfile`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserProfile`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public updateCoverPhoto(body?: models.PostUsersCurrentCoverphotoRequest, __unused?: any): Observable<models.ApiUserProfile> {
        return this.updateCoverPhotoRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserProfile', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserProfile`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserProfile`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public updateAvatar(body?: models.PostUsersCurrentAvatarRequest, __unused?: any): Observable<models.ApiUserProfile> {
        return this.updateAvatarRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserProfile', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserProfile`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserProfile`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public upsertUserOmniauth(body?: models.PostUsersCurrentOmniauthRequest, __unused?: any): Observable<models.ApiUserOmniauth> {
        return this.upsertUserOmniauthRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserOmniauth', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserOmniauth`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserOmniauth`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public spotSSO(body?: models.PostUsersCurrentSpotimRequest, __unused?: any): Observable<models.ApiSpotSSO> {
        return this.spotSSORequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('SpotSSO', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type SpotSSO`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type SpotSSO`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public spotAssociateUser(body?: models.PostUsersCurrentSpotimAssociateRequest, __unused?: any): Observable<{}> {
        return this.spotAssociateUserRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public mergeAccounts(body?: models.PostUsersMergeRequest, __unused?: any): Observable<models.ApiUserAuthToken> {
        return this.mergeAccountsRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('UserAuthToken', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type UserAuthToken`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type UserAuthToken`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public resetMyPassword(body?: models.PostUsersPasswordResetRequest, __unused?: any): Observable<{}> {
        return this.resetMyPasswordRequest(body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     */
    public disconnectExternalAccount(id?: string, __unused?: any): Observable<{}> {
        return this.disconnectExternalAccountRequest(id, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param userid 
     */
    public getPublicProfile(userid?: string, __unused?: any): Observable<models.ApiPublicProfile> {
        return this.getPublicProfileRequest(userid, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('PublicProfile', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type PublicProfile`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type PublicProfile`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param userid 
     * @param body 
     */
    public reportProfile(userid?: string, body?: models.PostUsersUseridReportRequest, __unused?: any): Observable<{}> {
        return this.reportProfileRequest(userid, body, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * Retrieve an authentication token for testing
     * 
     */
    public postUsersAuthTest(__unused?: any): Observable<{}> {
        return this.postUsersAuthTestRequest(__unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * Retrieve a specific user&#39;s auth token for testing (development only)
     * 
     * @param id 
     */
    public postUsersAuthTestId(id?: number, __unused?: any): Observable<{}> {
        return this.postUsersAuthTestIdRequest(id, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param identifier 
     */
    public resolveSpot(identifier?: number, __unused?: any): Observable<{}> {
        return this.resolveSpotRequest(identifier, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        

                        if (response.headers.get('X-Total') && rawData instanceof Array)
                            rawData['total'] = response.headers.get('X-Total');

                        return rawData;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param userid 
     */
    public translateSpotUserID(userid?: string, __unused?: any): Observable<models.ApiSpotUserLookupResult> {
        return this.translateSpotUserIDRequest(userid, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('SpotUserLookupResult', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type SpotUserLookupResult`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type SpotUserLookupResult`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public getOpenSessions(__unused?: any): Observable<PagedArray<models.ApiPlaybackSession>> {
        return this.getOpenSessionsRequest(__unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('PlaybackSession', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type PlaybackSession`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type PlaybackSession`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }


    /**
     * 
     * 
     * @param body 
     */
    public emailConflictRequest(body?: models.PostUsersEmailConflictRequest, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/email/conflict';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public getHonorRollRequest(extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiHonorRoll>>> {
        const path = this.basePath + '/users/honor-roll';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiHonorRoll>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param email 
     */
    public giftEligibleByEmailRequest(email?: string, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiGiftEligibility>> {
        const path = this.basePath + '/users/giftEligible';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        if (email !== undefined) {
            queryParameters['email'] = <any>email;
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiGiftEligibility>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public signupNewsletterRequest(body?: models.PostUsersSignupNewsletterRequest, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/signup/newsletter';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public signupRequest(body?: models.PostUsersSignupRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserAuthToken>> {
        const path = this.basePath + '/users/signup';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserAuthToken>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public confirmEmailRequest(body?: models.PostUsersConfirmemailRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserAuthToken>> {
        const path = this.basePath + '/users/confirmEmail';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserAuthToken>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * Resend confirmation email
     * 
     * @param body 
     */
    public sendConfirmationEmailRequest(body?: models.PostUsersSendconfirmationemailRequest, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/sendConfirmationEmail';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public unlockAccountRequest(body?: models.PostUsersUnlockaccountRequest, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/unlockAccount';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * Send an email to unlock account
     * 
     * @param body 
     */
    public requestAccountUnlockRequest(body?: models.PostUsersRequestunlockRequest, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/requestUnlock';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public resetPasswordRequest(body?: models.PostUsersResetpasswordRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserAuthToken>> {
        const path = this.basePath + '/users/resetPassword';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserAuthToken>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * Assume a user by token
     * 
     */
    public assumeRequest(extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserAuthToken>> {
        const path = this.basePath + '/users/assume';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserAuthToken>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * Send a password reset request
     * 
     * @param body 
     */
    public requestPasswordResetRequest(body?: models.PostUsersRequestpasswordresetRequest, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/requestPasswordReset';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * Authenticate using twitter, facebook, or google oauth credentials
     * 
     * @param body 
     */
    public userOmniauthAuthRequest(body?: models.PostUsersOmniauthRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserAuthToken>> {
        const path = this.basePath + '/users/omniauth';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserAuthToken>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public authenticateRequest(body?: models.PostUsersAuthRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserAuthToken>> {
        const path = this.basePath + '/users/auth';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserAuthToken>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public postUsersSsoRequest(extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/sso';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public getPaymentSourceRequest(extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiPaymentSource>> {
        const path = this.basePath + '/users/current/payment';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiPaymentSource>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param page 
     */
    public getAccountTransactionsRequest(page?: number, extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiAccountTransaction>>> {
        const path = this.basePath + '/users/current/transactions';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        if (page !== undefined) {
            queryParameters['page'] = <any>page;
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiAccountTransaction>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public deleteCurrentUserRequest(body?: models.PostUsersCurrentDeleteRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiDeletionConfirmation>> {
        const path = this.basePath + '/users/current/delete';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiDeletionConfirmation>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public getCurrentUserRequest(extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUser>> {
        const path = this.basePath + '/users/current';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUser>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public updateUserRequest(body?: models.PostUsersCurrentRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUser>> {
        const path = this.basePath + '/users/current';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUser>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param code 
     */
    public getRetentionOfferRequest(code?: string, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiRetentionOfferSet>> {
        const path = this.basePath + '/users/membership/retention/offers/{code}'
                    .replace('{' + 'code' + '}', String(code));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiRetentionOfferSet>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public reactivateMembershipRequest(extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiMembership>> {
        const path = this.basePath + '/users/current/membership/reactivate';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiMembership>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public cancelMembershipRequest(body?: models.PostUsersCurrentMembershipCancelRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiMembership>> {
        const path = this.basePath + '/users/current/membership/cancel';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiMembership>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public previewMembershipChangeRequest(body?: models.PostUsersCurrentMembershipModifyPreviewRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiMembershipChangePreview>> {
        const path = this.basePath + '/users/current/membership/modify/preview';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiMembershipChangePreview>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public modifyMembershipRequest(body?: models.PostUsersCurrentMembershipModifyRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiMembership>> {
        const path = this.basePath + '/users/current/membership/modify';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiMembership>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public refreshAuthenticationRequest(body?: models.PostUsersAuthRefreshRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserAuthToken>> {
        const path = this.basePath + '/users/auth/refresh';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserAuthToken>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public changePaymentSourceRequest(body?: models.PostUsersCurrentMembershipChangepaymentRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiMembership>> {
        const path = this.basePath + '/users/current/membership/changePayment';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiMembership>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public createMembershipRequest(body?: models.PostUsersCurrentMembershipRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiMembership>> {
        const path = this.basePath + '/users/current/membership';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiMembership>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public updateProfileRequest(body?: models.PostUsersCurrentProfileRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserProfile>> {
        const path = this.basePath + '/users/current/profile';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserProfile>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public updateCoverPhotoRequest(body?: models.PostUsersCurrentCoverphotoRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserProfile>> {
        const path = this.basePath + '/users/current/coverPhoto';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserProfile>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public updateAvatarRequest(body?: models.PostUsersCurrentAvatarRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserProfile>> {
        const path = this.basePath + '/users/current/avatar';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserProfile>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public upsertUserOmniauthRequest(body?: models.PostUsersCurrentOmniauthRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserOmniauth>> {
        const path = this.basePath + '/users/current/omniauth';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserOmniauth>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public spotSSORequest(body?: models.PostUsersCurrentSpotimRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiSpotSSO>> {
        const path = this.basePath + '/users/current/spotim';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiSpotSSO>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public spotAssociateUserRequest(body?: models.PostUsersCurrentSpotimAssociateRequest, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/current/spotim/associate';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public mergeAccountsRequest(body?: models.PostUsersMergeRequest, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiUserAuthToken>> {
        const path = this.basePath + '/users/merge';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiUserAuthToken>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public resetMyPasswordRequest(body?: models.PostUsersPasswordResetRequest, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/password/reset';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     */
    public disconnectExternalAccountRequest(id?: string, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/connected-accounts/{id}/disconnect'
                    .replace('{' + 'id' + '}', String(id));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param userid 
     */
    public getPublicProfileRequest(userid?: string, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiPublicProfile>> {
        const path = this.basePath + '/users/{userid}'
                    .replace('{' + 'userid' + '}', String(userid));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiPublicProfile>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param userid 
     * @param body 
     */
    public reportProfileRequest(userid?: string, body?: models.PostUsersUseridReportRequest, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/{userid}/report'
                    .replace('{' + 'userid' + '}', String(userid));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        headers['Content-Type'] = 'application/json';

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * Retrieve an authentication token for testing
     * 
     */
    public postUsersAuthTestRequest(extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/auth/test';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * Retrieve a specific user&#39;s auth token for testing (development only)
     * 
     * @param id 
     */
    public postUsersAuthTestIdRequest(id?: number, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/users/auth/test/{id}'
                    .replace('{' + 'id' + '}', String(id));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param identifier 
     */
    public resolveSpotRequest(identifier?: number, extraHttpRequestParams?: any): Observable<HttpResponse<{}>> {
        const path = this.basePath + '/spot/{identifier}'
                    .replace('{' + 'identifier' + '}', String(identifier));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<{}>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param userid 
     */
    public translateSpotUserIDRequest(userid?: string, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiSpotUserLookupResult>> {
        const path = this.basePath + '/spot/users/{userid}'
                    .replace('{' + 'userid' + '}', String(userid));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiSpotUserLookupResult>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public getOpenSessionsRequest(extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiPlaybackSession>>> {
        const path = this.basePath + '/content/playback/open_sessions';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // authentication (api_key) required

        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiPlaybackSession>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

}
